import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import PageTemplate from '../../components/template/PageTemplate';
import { TAG_PAGE_NAME } from '../../constants/service/app/tagConstants';
import TagEditlContainer from '../../containers/tag/TagEditContainer';
import { tagActions } from '../../store/modules/tag';
import { TAG_INFO_MODEL } from '../../store/modules/tag/models';

class TagCreate extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 태그 데이터 초기화
   */
  initiate = () => {
    const { setData } = this.props;

    setData({
      path: ['tagEdit'],
      value: {
        /**
         *  태그 정보
         */
        tagInfo: TAG_INFO_MODEL,
        /**
         *  태그 트렌드 메인 아이템 리스트
         */
        tagTabMain: {
          itemList: [],
          selectedItemList: {
            list: [],
            idList: [],
          },
        },
        /**
         *  태그 검색 리스트 SELECT
         */
        tagSearchSelectList: [],
        /**
         *  추천 태그 리스트 SELECT
         */
        recommendTagSelectList: [],
      },
    });
  };

  render() {
    const { insertTag } = this.props;

    return (
      <PageTemplate pageName={TAG_PAGE_NAME.TAG_CREATE}>
        <TagEditlContainer onSubmit={insertTag} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: tagActions.setData,
  insertTag: tagActions.insertTag,
};

export default connect(null, mapDispatchToProps)(withRouter(TagCreate));
